import React from 'react';

import { useStyles } from './styles';
import AssignmentLateOutlinedIcon from '@material-ui/icons/AssignmentLateOutlined';

type FormNotFoundProps = {
    errorMessage?: string;
};

const FormNotFound = ({
    errorMessage = 'The form you are looking for is no longer available.',
}: FormNotFoundProps) => {
    //TODO refactor the styles so that they are shared with FormSubmitted
    const classes = useStyles();

    return (
        <div className={classes.formSubmittedContainer}>
            <div className={classes.formSubmittedTitle}>Oops!</div>
            <div className={classes.formSubmittedSubtitle}>{errorMessage}</div>
            <div className={classes.formSubmittedIconContainer}>
                <AssignmentLateOutlinedIcon classes={{ root: classes.formSubmittedIcon }} />
            </div>
        </div>
    );
};

export default FormNotFound;
